<table class="table">
  <thead>
    <tr>
      <th scope="col" style="cursor: pointer;" sortable="name" (sort)="onSort($event)">Name</th>
      <th scope="col" style="cursor: pointer;" sortable="scheduledTime" (sort)="onSort($event)">Scheduled Start</th>
      <th scope="col">Official Start</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let event of test">
      <td>
        <a [routerLink]="[eventDetail, event.id]">{{ event.name }}</a>
      </td>
      <td>{{ event.scheduledTime?.toDate() | date:'yyyy/MM/dd h:mm:ss a'}}</td>
      <td>{{ event.officialTime?.toDate() | date:'yyyy/MM/dd h:mm:ss a'}}</td>
    </tr>
  </tbody>
</table>